class PillowQrPassport extends HTMLElement {
  connectedCallback() {
    this.stamp = this.querySelector('[data-passport-stamp]');
    this.formWrapper = this.querySelector('[data-form-wrapper]');
    if (!this.formWrapper || !this.stamp) return;

    this._observer = new MutationObserver(() => this.checkSuccess());
    this._observer.observe(this.formWrapper, { childList: true, subtree: true });
  }

  checkSuccess() {
    if (this._stamped) return;

    const wrapper = this.formWrapper;
    const found =
      wrapper?.querySelector('[data-testid="success-message"]') ||
      wrapper?.querySelector('.klaviyo-form-success') ||
      wrapper?.querySelector('[class*="success"]') ||
      wrapper?.querySelector('[class*="Success"]');

    if (found) {
      this._stamped = true;
      this.fireStamp();
    }
  }

  fireStamp() {
    const stamp = this.stamp;
    if (!stamp) return;

    stamp.setAttribute('aria-hidden', 'false');
    stamp.classList.add('is-visible');

    const codeEl = /** @type {HTMLElement|null} */ (stamp.querySelector('[data-stamp-code]'));
    if (!codeEl) return;

    const copyHint = stamp.querySelector('.pqp__stamp-copy-hint');
    /** @type {HTMLElement} */ (stamp).style.cursor = 'default';

    stamp.addEventListener('click', () => {
      const code = codeEl?.dataset.code || codeEl?.textContent || '';
      if (!code) return;
      navigator.clipboard?.writeText(code).then(() => {
        stamp.classList.add('is-copied');
        if (copyHint) copyHint.textContent = 'copied!';
        setTimeout(() => {
          stamp.classList.remove('is-copied');
          if (copyHint) copyHint.textContent = 'tap to copy';
        }, 2000);
      });
    });

    const text = codeEl.dataset.code || '';
    codeEl.textContent = '';
    let i = 0;

    const type = () => {
      if (i < text.length) {
        codeEl.textContent += text[i];
        i++;
        setTimeout(type, 60);
      }
    };

    setTimeout(type, 400);
  }

  disconnectedCallback() {
    this._observer?.disconnect();
  }
}

customElements.define('pillow-qr-passport', PillowQrPassport);
